import React from "react"
import Countdown from "react-countdown"

import styled from "styled-components"
import {
  BGWrapper,
  H2,
  H3,
  H5,
  StrongT,
  ButtonsWrapper,
  TextRow,
  DescWrapper,
  HeadingWrapper
} from "./UIStyle/UIstyle"
import { theme } from "./mixin"
import Button from "./Button"

import NextImg from "@/common/components/NextImg/index"

import PositionAndWidth from "./PositionAndWidth"
import Decoration from "./Decoration"
// images
import info1 from "@/common/assets/image/lucky-bag-2023/info1.webp"
import info2 from "@/common/assets/image/lucky-bag-2023/info2.webp"
import info3 from "@/common/assets/image/lucky-bag-2023/info3.webp"
import info4 from "@/common/assets/image/lucky-bag-2023/info4.webp"

const step_data = [
  { img: info1, desc: "點擊按鈕", desc2: "「立刻免費領取」" },
  { img: info2, desc: "輸入手機號碼", desc2: "收取簡訊通知" },
  { img: info3, desc: "下載並註冊", desc2: "KryptoGO Wallet" },
  { img: info4, desc: "領取玩具盒 ! ", desc2: "獲得抽獎資格" }
]

export default function SeriesOfEvents({ dayS }) {
  const renderer1 = ({ total, days, hours, minutes, seconds }) => {
    return (
      <>
        {!total ? (
          <Button
            className="hover"
            content="活動結束，感謝參與"
            id="toybox-infoButton1"
            secondary
            disable
          />
        ) : (
          <Button content="立刻領取" href="#top" id="toybox-infoButton1" />
        )}
      </>
    )
  }
  return (
    <Wrapper id="INFO" bg={theme.bgLinearTop}>
      <BGWrapper>
        <PositionAndWidth
          d={{ width: "10%", t: "2%", r: "20%" }}
          m={{ width: "clamp(30px,40%,120px)", t: "2%", r: "20%" }}
        >
          <Decoration type="blobman1" animation="updown" time={12} delay={0} />
        </PositionAndWidth>
      </BGWrapper>
      <ContentWrapper>
        <BGWrapper>
          <PositionAndWidth
            d={{ width: "00%", b: "0%", l: "-3%" }}
            m={{ width: "clamp(30px,40%,120px)", b: "0%", l: "-3%" }}
          >
            <Decoration
              type="blobman2"
              animation="updown"
              time={12}
              delay={6}
            />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "0%", b: "0px", r: "0%" }}
            m={{ width: "0%", b: "0px", r: "10%" }}
          >
            <Decoration
              type="blobman1"
              animation="updown"
              time={12}
              delay={4}
            />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "4%", t: "15%", r: "-2%" }}
            m={{ width: "8%", t: "40%", l: "-4%" }}
          >
            <Decoration type="circle" animation="updown" time={12} delay={3} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "1%", t: "50%", r: "-0.5%" }}
            m={{ width: "3%", t: "50%", r: "-1.5%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={9} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "1.5%", b: "-0.75%", l: "40%" }}
            m={{ width: "3%", b: "-0%", l: "40%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={2} />
          </PositionAndWidth>
        </BGWrapper>
        <HeadingWrapper>
          <H3 color={theme.CTAcolor}>INFO</H3>
          <H2>如何參與 ?</H2>
        </HeadingWrapper>
        <DescWrapper>
          <TextRow>
            <StrongT nowrap>活動期間：</StrongT>
            <StrongT>3月31日 上午11點 ～ 4月7日 下午11點</StrongT>
            <StrongT> </StrongT>
          </TextRow>
        </DescWrapper>
        <StepsWrapper>
          {step_data.map(({ img, desc, desc2 }, index) => (
            <StepsCard key={index}>
              <NextImg src={img} />
              <TextRow center>
                <H5 nowrap>{desc}</H5>
                <H5 nowrap>{desc2}</H5>
              </TextRow>
            </StepsCard>
          ))}
        </StepsWrapper>
        <ButtonsWrapper>
          {/* <Button
            content="立刻領取"
            arrow
            href="#top"
            id="toybox-infoButton1"
          /> */}
          <Countdown date={dayS} renderer={renderer1} />
          <Button
            content="FAQ"
            secondary
            arrow
            blank
            id="toybox-infoButton2"
            href="https://kryptogo.notion.site/KryptoGO-x-91APP-NFT-3ce05f20b3a34a6487c76a5713e8bde3"
          />
        </ButtonsWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg};
  @media (${theme.md}) {
    padding: 60px 20px 60px 20px;
  }
`
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 73px;
  width: 100%;
  max-width: 1400px;
  gap: 32px;
  padding: 60px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (${theme.xl}) {
    border-radius: 36px;
  }
  @media (${theme.lg}) {
    border-radius: 36px;
    padding: 60px 20px 60px 20px;
  }

  @media (${theme.md}) {
    padding: 60px 20px 60px 20px;
    gap: 36px;
  }
`

const StepsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  gap: 40px;
  padding: 20px 0 30px 0;
  align-items: start;
  @media (${theme.xl}) {
    width: clamp(0px, 100%, 500px);
    grid-template-columns: repeat(2, 1fr);
  }
  @media (${theme.md}) {
    gap: 12px;
    width: clamp(0px, 100%, 400px);
    grid-template-columns: repeat(2, 1fr);
  }
`
const StepsCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`
const A = styled.div``
